import DataTable from "@/components/DataTable";
import { DataType } from "@/components/DataTable/Models";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { BlockTableEditorProps, DataTableTemplateConfig } from "../../Models";

const BlockTableEditor = ({
    data,
    config,
    matrix,
    matrixType,
    software,
    classifications,
    useCases,
    disciplines,
    onChange,
}: BlockTableEditorProps) => {
    const [tableConfig, setTableConfig] = useState<DataTableTemplateConfig>();

    useEffect(() => {
        if (config.hasSoftwareColumns || config.hasClassificationColumns) {
            const data = { ...config };

            if (config.hasSoftwareColumns) {
                const sorted = software.sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.name.localeCompare(b.name));

                for (let i = 0; i < sorted.length; i++) {
                    if (data.columns.findIndex((x) => x.value === sorted[i].name) === -1)
                        data.columns.push({
                            value: sorted[i].name,
                            dataType: DataType.STRING,
                            metadata: { softwareId: sorted[i].id },
                        });
                }
            }

            if (config.hasClassificationColumns && classifications) {
                const sorted = classifications.sort(
                    (a, b) => (a.order ?? 0) - (b.order ?? 0) || (a.name ?? "").localeCompare(b.name ?? "")
                );

                for (let i = 0; i < sorted.length; i++) {
                    if (data.columns.findIndex((x) => x.value === sorted[i].name) === -1)
                        data.columns.push({
                            value: sorted[i].name,
                            dataType: DataType.STRING,
                            metadata: { classificationId: sorted[i].id },
                        });
                }
            }

            setTableConfig({ ...data, useCases, disciplines });
        } else setTableConfig({ ...config, useCases, disciplines });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box m={1} mb={3}>
            {tableConfig && (
                <DataTable
                    config={tableConfig}
                    data={data}
                    dataSource={matrix}
                    dataSourceType={matrixType}
                    onChange={onChange}
                    activeDisciplines={[]}
                />
            )}
        </Box>
    );
};

export default BlockTableEditor;
